import React from 'react';
import PropTypes from 'prop-types';

export const APPLE_DEFAULT_COLOR = '#1A1A1A';

export default function Apple({ logoColor, logoWidth, logoHeight }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={logoWidth} height={logoHeight} viewBox="0 0 21 24" fill="none">
            <title>Calendar Attachment Apple</title>
            <path
                d="M19.6458 8.18242C19.5066 8.29043 17.0487 9.67537 17.0487 12.7549C17.0487 16.3168 20.1762 17.577 20.2698 17.6082C20.2554 17.685 19.773 19.3339 18.6209 21.0141C17.5936 22.4926 16.5207 23.9688 14.8885 23.9688C13.2563 23.9688 12.8363 23.0207 10.9521 23.0207C9.11593 23.0207 8.46307 24 6.97012 24C5.47717 24 4.43546 22.6319 3.23774 20.9517C1.8504 18.9787 0.729492 15.9136 0.729492 13.0045C0.729492 8.33843 3.7634 5.86379 6.74929 5.86379C8.33585 5.86379 9.65839 6.90549 10.6545 6.90549C11.6026 6.90549 13.0811 5.80138 14.8861 5.80138C15.5702 5.80138 18.028 5.86379 19.6458 8.18242ZM14.0292 3.82598C14.7757 2.94029 15.3038 1.71137 15.3038 0.482448C15.3038 0.312031 15.2893 0.139214 15.2581 0C14.0436 0.0456046 12.5987 0.808881 11.7274 1.81938C11.0433 2.59706 10.4049 3.82598 10.4049 5.07171C10.4049 5.25893 10.4361 5.44614 10.4505 5.50615C10.5273 5.52055 10.6521 5.53735 10.7769 5.53735C11.8666 5.53735 13.2371 4.80768 14.0292 3.82598Z"
                fill={logoColor || APPLE_DEFAULT_COLOR}
            />
        </svg>
    );
}

Apple.defaultProps = {
    logoColor: null,
    logoWidth: 21,
    logoHeight: 24,
};
Apple.propTypes = {
    logoColor: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
};
